import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { Translate } from 'react-redux-i18n'
import EventEmitter, { SHOW_TOAST_MESSAGE } from '../../../helpers/EventEmitter'
import UserManagementService from '../../store/services/UserManagementService'

export const putUserSetting = createAsyncThunk(
  'userManagement/settingPreferences/putUserSetting',
  async (params, { rejectWithValue }) => {
    try {
      const res = await UserManagementService.putUserSetting(params)
      if (res.success) {
        EventEmitter.dispatch(SHOW_TOAST_MESSAGE, {
          message: <Translate value="settingPreferences.CHANGE_SAVED" />,
        })

        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getUserSettingWithPreference = createAsyncThunk(
  'userManagement/settingPreferences/getUserSettingWithPreference',
  async (params, { rejectWithValue }) => {
    try {
      const res = await UserManagementService.getUserSettingWithPreference(
        params,
      )
      if (res.success) {
        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const putUserSettingAlternative = createAsyncThunk(
  'userManagement/settingPreferences/putUserSettingAlternative',
  async (params, { rejectWithValue }) => {
    try {
      const res = await UserManagementService.putUserSettingAlternative(params)
      if (res.success) return res.data
      return rejectWithValue({ loading: false })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)
